/**
 * Builds the fetchLocations payload for a rectangular-area search.
 *
 * Shared by searchWithinMap.plugin (explicit user click, near me) and
 * viewportSearch.plugin (rectangle follow and drift activation from its
 * policies) so every flow requests the same shape of rectangular-area search
 * from the API.
 *
 * Pure — no side effects, no SDK coupling.
 *
 * @module searchResultsMap/services/rectangularAreaSearchPayload
 */

import { LocationType } from 'features/searchResultsFacets';
import { areBoundsValid } from './geometry';

const RECTANGULAR_AREA = LocationType.RectangularArea.toString();

/**
 * @param {{ south: number, north: number, west: number, east: number }|null} bounds
 *   Search bounds, already expanded for site plans by getSearchBounds.
 * @returns {Object|null} fetchLocations payload, or null when bounds are missing/invalid
 */
function createFetchLocationsPayload(bounds) {
  if (!areBoundsValid(bounds)) {
    return null;
  }

  const { south, north, west, east } = bounds;

  return {
    locationType: RECTANGULAR_AREA,
    minimumLatitude: south,
    maximumLatitude: north,
    minimumLongitude: west,
    maximumLongitude: east,
  };
}

export default createFetchLocationsPayload;